import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const Wrapper = styled.div`
	margin-top: 28px;
	text-align: center;

	${minWidth('tablet')} {
		margin-top: 0;
	}
`;

export const Heading = styled.h1`
	${fontSize(FontSizes.xl)};
	color: ${palette('gray7')};
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 32px;
`;
